const items = [
  { label: '원수 정수공정(PU-01)', value: 'PU-01' },
  { label: '용수 정수공정(PU-02)', value: 'PU-02' },
  { label: 'Roll 연마공정(PU-03)', value: 'PU-03' },
  { label: 'Knife 연마공정(PU-04)', value: 'PU-04' },
  { label: '약품투입공정(PU-05)', value: 'PU-05' },


  { label: '열간암연/압출공정(P-01)', value: 'P-01' },
  { label: '열간암연/압출공정(P-01)_생산품', value: 'P-01_생산품' },
  { label: '열간암연/압출공정(P-01)_처리', value: 'P-01_처리' },
  { label: '열간암연/압출공정(P-01)_후판', value: 'P-01_후판' },
  { label: '열간암연/압출공정(P-01)_판매', value: 'P-01_판매' },
  { label: '제품 시험공정(P-02)', value: 'P-02' },
  { label: '위험물 저장공정(PE-01)', value: 'PE-01' },

  { label: '폐수처리공정(물리화학적 폐수처리, PW-01)', value: 'PW-01' },
  { label: '폐기물 보관공정(지정&일반, PW-02)', value: 'PW-02' },
  { label: '비점오염 저감공정(PW-03)', value: 'PW-03' },
]

export default {
  items,
  getLabel(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value).label || ''
    }

    return ''
  },
  getValue(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label).value || ''
    }
    return ''
  },
  findItems(label) {
    return items.filter(item => item.label.indexOf(label) > -1) || []
  },
  getItemWithLabel(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label) || ''
    }

    return ''
  },
  getItemWithValue(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value) || ''
    }

    return ''
  }
}
